import {
  MAX_VALUE_ON_PRICE_RANGE,
  MIN_VALUE_ON_PRICE_RANGE,
  N_SLIDER_MIN_VALUE,
  RESULTS_SORT_OPTIONS,
} from '../../Constants';
import { SUCCESS } from '../constants';
import { GET_INIT_DATA } from '../init/action-types';
import { toggleReduxArrayItem } from '../utils';
import {
  ADD_B_FILTERS,
  ADD_N_FILTERS,
  RESET_ALL_FILTERS,
  SET_PET_FRIENDLY_SELECTED,
  SET_RESULTS_APPLIED_SORT,
  TOGGLE_B_FILTER,
  TOGGLE_PET_FRIENDLY_SELECTED,
  UPDATE_MAX_VALUE,
  UPDATE_MIN_VALUE,
  ACCOM_TOGGLE_FILTER,
  ACCOM_UPDATE_MIN_VALUE,
  ACCOM_UPDATE_MAX_VALUE,
  ACCOM_SUPPLIED_SORT,
  ACCOM_RESET_FILTERS,
  ACCOM_UPDATE_BATHROOMS,
  ACCOM_UPDATE_BEDROOMS,
} from './action-types';

export const N_FILTERS_STATE_KEY = 'nFiltersStateArray';
const N_FILTER_GROUP = 2;

const defaultState = {
  bFiltersStateArray: [],
  nFiltersStateArray: [],
  nFiltersDefaultArray: [],
  petFriendlySelected: false,
  rangeSliderMin: MIN_VALUE_ON_PRICE_RANGE,
  rangeSliderMax: MAX_VALUE_ON_PRICE_RANGE,
  resultsAppliedSort: RESULTS_SORT_OPTIONS[0],
  accom: {
    filtersStateArray: [],
    rangeSliderMin: MIN_VALUE_ON_PRICE_RANGE,
    rangeSliderMax: MAX_VALUE_ON_PRICE_RANGE,
    appliedSort: RESULTS_SORT_OPTIONS[0],
    bathrooms: N_SLIDER_MIN_VALUE,
    bedrooms: N_SLIDER_MIN_VALUE,
  },
};

export const reducer = (state = defaultState, action) => {
  switch (action.type) {
    case RESET_ALL_FILTERS: {
      return {
        ...defaultState,
        nFiltersStateArray: state.nFiltersDefaultArray,
        nFiltersDefaultArray: state.nFiltersDefaultArray,
      };
    }
    case GET_INIT_DATA + SUCCESS: {
      if (action.payload.response.data.data.Filters) {
        const nFiltersLength = action.payload.response.data.data.nFilters[N_FILTER_GROUP].length;
        const nFiltersDefaultArray = Array(nFiltersLength).fill(N_SLIDER_MIN_VALUE);

        return {
          ...state,
          nFiltersStateArray: nFiltersDefaultArray,
          nFiltersDefaultArray,
        };
      }
      return state;
    }
    case TOGGLE_B_FILTER: {
      const { bFiltersStateArray } = state;
      const value = action.payload;

      const newSelectedBFilters = toggleReduxArrayItem(bFiltersStateArray, value);

      return { ...state, bFiltersStateArray: newSelectedBFilters };
    }
    case ADD_B_FILTERS:
      return {
        ...state,
        bFiltersStateArray: [...new Set([...state.bFiltersStateArray, ...action.payload])],
      };
    case ADD_N_FILTERS:
      return {
        ...state,
        nFiltersStateArray: action.payload,
      };
    case TOGGLE_PET_FRIENDLY_SELECTED:
      return {
        ...state,
        petFriendlySelected: !state.petFriendlySelected,
      };
    case SET_PET_FRIENDLY_SELECTED:
      return {
        ...state,
        petFriendlySelected: action.payload,
      };
    case UPDATE_MAX_VALUE:
      return {
        ...state,
        rangeSliderMax: Math.min(action.payload, MAX_VALUE_ON_PRICE_RANGE),
      };
    case UPDATE_MIN_VALUE:
      return {
        ...state,
        rangeSliderMin: Math.max(action.payload, 0),
      };
    case SET_RESULTS_APPLIED_SORT:
      return {
        ...state,
        resultsAppliedSort: action.payload,
      };
    // Accom
    case ACCOM_TOGGLE_FILTER: {
      const filter = action.payload;

      const filtersStateArray = state.accom.filtersStateArray.includes(filter)
        ? state.accom.filtersStateArray.filter((item) => item !== filter)
        : [...state.accom.filtersStateArray, filter];

      return {
        ...state,
        accom: {
          ...state.accom,
          filtersStateArray,
        },
      };
    }
    case ACCOM_UPDATE_MAX_VALUE:
      return {
        ...state,
        accom: {
          ...state.accom,
          rangeSliderMax: Math.min(action.payload, MAX_VALUE_ON_PRICE_RANGE),
        },
      };
    case ACCOM_UPDATE_MIN_VALUE:
      return {
        ...state,
        accom: {
          ...state.accom,
          rangeSliderMin: Math.max(action.payload, 0),
        },
      };
    case ACCOM_SUPPLIED_SORT:
      return {
        ...state,
        accom: {
          ...state.accom,
          appliedSort: action.payload,
        },
      };
    case ACCOM_RESET_FILTERS:
      return {
        ...state,
        accom: { ...defaultState.accom },
      };
    case ACCOM_UPDATE_BEDROOMS:
      return {
        ...state,
        accom: {
          ...state.accom,
          bedrooms: action.payload,
        },
      };
    case ACCOM_UPDATE_BATHROOMS:
      return {
        ...state,
        accom: {
          ...state.accom,
          bathrooms: action.payload,
        },
      };
    default:
      return state;
  }
};

export default reducer;
